import { type ComponentType, type ReactNode, useState } from "react";
import { Form, Formik } from "formik";
import Button from "../UI/Button";
import Callout from "../UI/Callout";
import Text from "../UI/Text";
import Title from "../UI/Title";
import FormikSubmitButton from "../UI/FormikSubmitButton";
// @ts-expect-error pure js
import TextInput from "../UI/TextInput";
// @ts-expect-error pure js
import useAuthenticatedAxios from "../../hooks/use-authenticated-axios";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils";
import type { Balance } from "../../models/balance";
import styles from "./AvoirForm.module.css";

type ModalElementProps = {
  onClose?: () => void;
  size?: "small" | "medium" | "large";
  children?: ReactNode;
  className?: string;
};

interface AvoirFormProps {
  ModalElement: ComponentType<ModalElementProps>;
  balance: Balance | null;
  onSubmit: () => Promise<void>;
}

interface AvoirFormValues {
  motif: string;
}

const INITIAL_VALUES: AvoirFormValues = { motif: "" };

export default function AvoirForm({
  ModalElement,
  balance,
  onSubmit,
}: AvoirFormProps) {
  const axios = useAuthenticatedAxios();
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(values: AvoirFormValues) {
    if (!balance!.correlation_id) {
      setError("Cette écriture n'est pas liée à un groupe de facture.");
      return;
    }
    setError(null);
    try {
      await axios.post(`/tenants/${balance!.id_tenant}/avoir`, {
        correlation_id: balance!.correlation_id,
        motif: values.motif || null,
      });
      await onSubmit();
    } catch (e) {
      setError(handleAPIError(e));
    }
  }

  return (
    <ModalElement size="small">
      <div className={styles.form}>
        <Title>Annuler la facture (avoir)</Title>
        <Text>
          Un avoir sera généré pour annuler les écritures liées à cette facture.
          Les montants seront inversés dans la comptabilité.
        </Text>
        <Formik initialValues={INITIAL_VALUES} onSubmit={handleSubmit}>
          <Form>
            <TextInput
              name="motif"
              label="Motif (optionnel)"
              placeholder="Erreur de facturation"
            />
            <Callout variant="danger">{error}</Callout>
            <div className={styles.actions}>
              <Button type="button" variant="secondary" onClick={onSubmit}>
                Annuler
              </Button>
              <FormikSubmitButton requiresWrite>
                Confirmer l'avoir
              </FormikSubmitButton>
            </div>
          </Form>
        </Formik>
      </div>
    </ModalElement>
  );
}
